<template>
  <div class="contents">
    <h4>店舗選択</h4>
    <el-tabs type="border-card">
      <el-tab-pane label="店舗切り替え">
        <shop-select-shop-table />
      </el-tab-pane>
      <el-tab-pane label="グループ切り替え">
        <shop-select-group-table />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ShopSelectShopTable from './ShopTable'
import ShopSelectGroupTable from './GroupTable'
import {mapActions} from 'vuex'

export default {
  name: 'ShopSelect',
  components: {
    ShopSelectShopTable,
    ShopSelectGroupTable,
  },
  data () {
    return {
    }
  },
  mounted () {
    this.resetAsShop()
    this.resetAsGroup()
  },
  methods: {
    ...mapActions('account', ['resetAsShop', 'resetAsGroup']),
  },
}
</script>

<style scoped>
div.contents {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/ShopSelect/Index.vue